/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'

// Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)

import api from './_api'
Vue.prototype.$api = api

import BlockUI from 'vue-blockui'
Vue.use(BlockUI)

import money from 'v-money'
Vue.use(money, { precision: 2 })
import { VMoney } from 'v-money'
Vue.directive("money", VMoney);

import Notifications from 'vue-notification'
Vue.use(Notifications)


import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const toastOptions = {
  // You can set your default options here
  timeout: false,
  position: 'top-center',
  closeOnClick: false,
};

import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(Toast, toastOptions);

import axios from 'axios'

import interceptorsSetup from './_api/axiosInterceptor'
interceptorsSetup()

import VueGoodTablePlugin from 'vue-good-table';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

Array.prototype.groupBy = function (prop) {
  return this.reduce(function (groups, item) {
    const val = item[prop]
    groups[val] = groups[val] || []
    groups[val].push(item)
    return groups
  }, {})
}

// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

//CSS
// <!-- Bootstrap 4 -->
// require('bootstrap/dist/css/bootstrap.css')
require('bootstrap-vue/dist/bootstrap-vue.css')

/* Font Awesome */
// require('../adminlte/plugins/fontawesome-free/css/all.min.css')
// require('../AdminLTE/fontawesome/font-awesome.min.css')
// require('../adminLTE/plugins/fontawesome/font-awesome.min.css')
/* overlayScrollbars */
require('../adminLTE/dist/css/adminlte.min.css')

//JavaScripts
// jQuery
//require('@/adminlte/plugins/jquery/jquery.min.js');

// adicionando jQuery ao projeto
global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

// <!-- AdminLTE App -->
require('../adminLTE/dist/js/adminlte.min.js');

// charts CSS
require('./utils/c3.css')

//Fonte Lato
require('./utils/css/lato.css')
Vue.config.productionTip = false

store.subscribe((mutation, state) => {
  if (mutation.type === 'setUser' && mutation.payload) {
    localStorage.setItem('user', JSON.stringify(mutation.payload))
  } else 
  if (mutation.type === 'logout') {
    localStorage.removeItem('user');
  }
})

new Vue({
  el: '#app',
  axios,
  router,
  store,
  axios,
  components: { App },
  template: '<App/>',
  beforeCreate () {
    this.$store.commit('initializeStore');
  }
})



// WEBPACK FOOTER //
// ./src/main.js